// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonGhost_base--HIJK0","caption":"ButtonGhost_caption--2SRvz"};


//////////////////
// WEBPACK FOOTER
// ./components/ButtonGhost/ButtonGhost.scss
// module id = 2445
// module chunks = 11